import React, { useEffect, useState } from "react";
import axios from "../axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { QRCodeCanvas } from "qrcode.react"; // ✅ Ajouté ici
import "../styles/vendor.css";

const MesProduits = () => {
  const [mesProduits, setMesProduits] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [editingProductId, setEditingProductId] = useState(null);
  const [editedProduct, setEditedProduct] = useState({});
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    if (!user?.id) {
      toast.error("⛔ Accès interdit. Veuillez vous connecter.");
      navigate("/login");
      return;
    }

    const fetchMesProduits = async () => {
      try {
        const res = await axios.get(`/products/vendor/${user.id}`);
        setMesProduits(res.data);

        if (res.data.length > 0) {
          const first = res.data[0];
          setSelectedProductId(first._id);
          setEditingProductId(first._id);
          setEditedProduct({ ...first });
        }
      } catch (err) {
        console.error("Erreur récupération produits vendeur :", err);
        toast.error("❌ Impossible de charger vos produits.");
      }
    };

    fetchMesProduits();
  }, [user, navigate]);

  const handleProductSelect = (e) => {
    const prod = mesProduits.find((p) => p._id === e.target.value);
    if (prod) {
      setEditingProductId(prod._id);
      setEditedProduct({ ...prod });
      setSelectedProductId(e.target.value);
    }
  };

  const cancelEdit = () => {
    setEditingProductId(null);
    setEditedProduct({});
    setSelectedProductId("");
  };

  const saveEdit = async () => {
    try {
      const response = await axios.put(`/products/${editingProductId}`, editedProduct);
      toast.success("✅ Produit mis à jour");
      const updated = mesProduits.map((p) =>
        p._id === editingProductId ? { ...p, ...editedProduct } : p
      );
      setMesProduits(updated);
      cancelEdit();
    } catch (err) {
      console.error("❌ Erreur mise à jour produit :", err);
      toast.error("❌ Impossible de mettre à jour ce produit.");
    }
  };

  return (
    <div className="vd-page">
      <div className="vd-section-header">
        <h2 className="vd-section-title">🛍️ Mes produits</h2>
      </div>

      {mesProduits.length === 0 ? (
        <div className="vd-card" style={{ textAlign: "center", color: "#94A3B8" }}>
          Vous n'avez encore ajouté aucun produit.
        </div>
      ) : (
        <>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12, marginBottom: 20 }}>
            {mesProduits.map((prod) => (
              <li key={prod._id} className="vd-card vd-product-item" style={{ flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                  <span className="vd-product-name">{prod.articleName}</span>
                  <span className={`vd-status-badge vd-status-${prod.status?.replace(/\s/g, "-")}`}>
                    {prod.status}
                  </span>
                </div>
                <div className="vd-product-meta">
                  <span>📦 {prod.productId}</span>
                  {prod.city && <span>📍 {prod.city}</span>}
                </div>
                <div className="vd-qr-mini">
                  <QRCodeCanvas
                    value={`${window.location.origin}/product/${prod.productId}`}
                    size={80}
                    includeMargin={true}
                  />
                </div>
              </li>
            ))}
          </ul>

          <div className="vd-card">
            <div className="vd-card-title" style={{ marginBottom: 14 }}>✏️ Modifier un produit existant</div>
            <div className="vd-form-group">
              <select
                className="vd-select"
                value={selectedProductId}
                onChange={handleProductSelect}
              >
                <option value="">Sélectionner un produit</option>
                {mesProduits.map((prod) => (
                  <option key={prod._id} value={prod._id}>
                    {prod.articleName} — {prod.productId}
                  </option>
                ))}
              </select>
            </div>

            {editingProductId && (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <div className="vd-form-group">
                  <input
                    className="vd-input"
                    value={editedProduct.articleName}
                    onChange={(e) =>
                      setEditedProduct({ ...editedProduct, articleName: e.target.value })
                    }
                    placeholder="Nom du produit"
                  />
                </div>
                <div className="vd-form-group">
                  <textarea
                    className="vd-textarea"
                    value={editedProduct.description || ""}
                    onChange={(e) =>
                      setEditedProduct({ ...editedProduct, description: e.target.value })
                    }
                    placeholder="Description"
                  />
                </div>
                <div className="vd-form-group">
                  <select
                    className="vd-select"
                    value={editedProduct.status}
                    onChange={(e) =>
                      setEditedProduct({ ...editedProduct, status: e.target.value })
                    }
                  >
                    <option value="en stock">Disponible</option>
                    <option value="promotion">Promotion</option>
                    <option value="indisponible">Indisponible</option>
                  </select>
                </div>
                <div className="vd-btn-row">
                  <button className="vd-btn-primary" onClick={saveEdit}>
                    💾 Enregistrer
                  </button>
                  <button className="vd-btn-ghost" onClick={cancelEdit}>
                    Annuler
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MesProduits;
